import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Showtime } from '../models';
import { API_BASE, params } from './api';

@Injectable({ providedIn: 'root' })
export class ShowtimeService {
  constructor(private readonly http: HttpClient) {}

  list(filters: { movie?: string; cinema?: string; county?: string; date?: string; chain?: string; language?: string } = {}) {
    return this.http.get<Showtime[]>(`${API_BASE}/showtimes${params(filters)}`);
  }
}
